import Guide from 'types/Guide';
import VideoResource from 'types/VideoResource';

import {
  CURATED_TAG_FILTERS,
  ResourceFilters,
  parseTags,
} from './VideoResources/VideoResources.helpers';

// The only pills that map onto a guide's age_group: "Baby" covers the pre-adult
// bands, "Adult" maps to adult. Vaginal and Tiny+ Exclusive are video-only.
const BABY_AGE_GROUPS = new Set(['baby', 'toddler', 'child']);
const GUIDE_AGE_PILLS = new Set<string>(['Baby', 'Adult']);

const pillMatchesAgeGroup = (pill: string, ageGroup?: string): boolean => {
  if (pill === 'Adult') return ageGroup === 'adult';
  if (pill === 'Baby') return BABY_AGE_GROUPS.has(ageGroup ?? '');
  return false;
};

// Guides only carry an age dimension, so they're filtered by the active age
// pills (OR semantics). Pills guides have no concept of — Vaginal, Tiny+
// Exclusive — are ignored here rather than emptying the section.
export const matchesGuideFilters = (
  guide: Guide,
  { tags }: ResourceFilters,
): boolean => {
  const agePills = tags.filter(tag => GUIDE_AGE_PILLS.has(tag));
  if (!agePills.length) return true;
  return agePills.some(tag => pillMatchesAgeGroup(tag, guide.age_group));
};

// A curated pill shows in the shared filter bar if any visible video carries
// the tag, or any guide's age_group maps to it.
export const computeAvailablePills = (
  videos: VideoResource[] | undefined,
  guides: Guide[] | undefined,
): string[] => {
  const videoTags = new Set<string>();
  videos?.forEach(video =>
    parseTags(video.tags).forEach(tag => videoTags.add(tag)),
  );
  return CURATED_TAG_FILTERS.filter(
    pill =>
      videoTags.has(pill) ||
      (guides ?? []).some(guide => pillMatchesAgeGroup(pill, guide.age_group)),
  );
};
